// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const ATTRIBUTE_BUNDLE_SETTINGS_KEY_TO_PERSISTENCE_KEY = {
  BUNDLE_VISIBLE: 'bundle.visible',
  FEATURE_INFO_ENABLED: 'featureInfo.enabled',
  FEATURE_INFO_AUTO_MODE_ENABLED: 'featureInfo.auto.enabled',
  FEATURE_INFO_HEADLINE_TYPE: 'featureInfo.headline.mode',
  FEATURE_INFO_HEADLINE_CUSTOM: 'featureInfo.headline.custom',
  FEATURE_INFO_PIE_CHART_SLICE_RESOLVING_ENABLED: 'featureInfo.pieChartSliceResolving.enabled',
  FEATURE_INFO_ATTRIBUTE_TABLE_ENABLED: 'featureInfo.attributeTable.enabled',
  CIRCLE_SECTORS_DIRECTION_FALLBACK_BEHAVIOUR: 'circleSectors.direction.fallback.behaviour',
  CIRCLE_SECTORS_FIXED_CENTRAL_ANGLE_ENABLED: 'circleSectors.centralAngle.fixed.enabled',
  CIRCLE_SECTORS_FIXED_CENTRAL_ANGLE: 'circleSectors.centralAngle.fixed.value',
  CIRCLE_SECTORS_CENTRAL_ANGLE_FALLBACK_BEHAVIOUR: 'circleSectors.centralAngle.fallback.behaviour',
  CIRCLE_SECTORS_CENTRAL_ANGLE_FALLBACK_VALUE: 'circleSectors.centralAngle.fallback.value',
  CIRCLE_SECTORS_FIXED_RADIUS_ENABLED: 'circleSectors.radius.fixed.enabled',
  CIRCLE_SECTORS_RADIUS_UNIT: 'circleSectors.radius.unit',
  CIRCLE_SECTORS_FIXED_RADIUS_VALUE: 'circleSectors.radius.fixed.value',
  CIRCLE_SECTORS_FIXED_RADIUS_UNIT: 'circleSectors.radius.fixed.unit',
  CIRCLE_SECTORS_RADIUS_FALLBACK_BEHAVIOUR: 'circleSectors.radius.fallback.behaviour',
  CIRCLE_SECTORS_RADIUS_FALLBACK_VALUE: 'circleSectors.radius.fallback.value',
  CIRCLE_SECTORS_RADIUS_FALLBACK_UNIT: 'circleSectors.radius.fallback.unit'
} as const;

/** @see net/disy/cadenza/workbook/model/AttributeBundleSettingsKey.java */
export type AttributeBundleSettingsKey = keyof typeof ATTRIBUTE_BUNDLE_SETTINGS_KEY_TO_PERSISTENCE_KEY;

export const AttributeBundleSettingsKey = {
  values: Object.keys(ATTRIBUTE_BUNDLE_SETTINGS_KEY_TO_PERSISTENCE_KEY) as readonly AttributeBundleSettingsKey[],
  toPersistenceKey: (value: AttributeBundleSettingsKey) => ATTRIBUTE_BUNDLE_SETTINGS_KEY_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = AttributeBundleSettingsKey.values.find(key => ATTRIBUTE_BUNDLE_SETTINGS_KEY_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No AttributeBundleSettingsKey for key: ${persistenceKey}`); }
    return value;
  },
} as const;

// </GENERATED-CODE>
